<template>
  <div>
    <!-- <div class="search-header">
      <tol-type-ahead
        :icon-config="{ label: 'Go' }"
        :search-params="{}"
        menu-label="What are you looking for?"
      >
      </tol-type-ahead>
    </div> -->
    <hr />
    <div class="report-builder">
      <div class="rb-msg">Build Your Own Report</div>
      <div class="bl">
        <span>Search for:</span>
        <div class="rb-input">
          <dropdown-select
            :menu-items="menu"
            class="bordered"
            :selected-item="selectedTable"
            @select-item="showDefaultUIForSelected($event)"
            @clear-item="clearDefaultUIForSelected()"
          >
          </dropdown-select>
        </div>
      </div>

      <div v-if="selectedTable" class="bl main">
        <div class="rb-input ext">
          <data-filter-form :table="selectedTable" :filters="defaults"></data-filter-form>
        </div>
      </div>

      <div class="bl right">
        <div class="search" :class="{ disabled: !selectedTable }" @click="doAdvancedSearch()">
          Search
        </div>
      </div>
    </div>
    <div v-if="searchClicked">
      <div v-if="selectedTable" class="bl main">
        <div v-show="searchResults.length > 0" class="rb-input">
          <search-result-field-toggle
            :field-list="currentSearchResultFields"
            :display-fields="selectedFields.map(f => f.toLowerCase())"
            @selected="setSearchField($event)"
            @removed="removeSearchField($event)"
          />
        </div>
      </div>

      <search-export-actions />

      <tol-table
        :table-data="searchResults"
        :columns="viewFieldNames"
        :show-spinner="isLoading"
        :is-row-clickable="true"
        @row-click="handleSearchRowClicked($event)"
      >
        <template v-slot:tableHeader>
          <th></th>
          <!-- empty header column for checkboxes -->
          <template v-for="f in selectedFields">
            <th v-if="!sortableFields.includes(f.toLowerCase())" :key="f">
              {{ f }}
            </th>
            <th-sortable
              v-else
              :key="f"
              :direction="searchResultSortField === f ? searchResultSortDirection : 'none'"
              :field-name="f"
              @change="onSortOrderChange"
              >{{ f }}</th-sortable
            >
          </template>
        </template>
        <template v-slot:check="{ value }">
          <td class="row-select" @click.stop>
            <Checkbox
              :checked="selectedSearchResults.includes(value.reference_number)"
              @change="onToggleSelectSearchResult(value.reference_number)"
            />
          </td>
        </template>
        <template v-slot:start_date="{ value }">
          <font-awesome-icon icon="calendar-alt" />
          {{ value.start_date }}
        </template>

        <template v-slot:end_date="{ value }">
          <font-awesome-icon icon="calendar-alt" />
          {{ value.end_date }}
        </template>

        <template v-slot:has_attachment="{ value }">
          {{ value.has_attachment === 'True' ? 'Yes' : 'No' }}
        </template>

        <template v-slot:stop_date="{ value }">
          <font-awesome-icon icon="calendar-alt" />
          {{ value.stop_date }}
        </template>
        <template v-slot:status="{ value }">
          <Status :status="value.status" object-type="assignment" />
        </template>
      </tol-table>
      <search-export-actions />
      <Pagination
        :records-per-page="searchResultsPerPage"
        :offset="currentPage"
        :record-count="searchResultsCount"
        @change="onChangePaginationParams($event)"
      />
    </div>
    <div v-else-if="previousSearchResult">
      <ConfirmModal
        :is-yes-no-modal="true"
        title="Show previous search result"
        action="UPDATE_APPROVER"
        @yes-action="searchClicked = true"
        @cancel-action="cancelPreviousSearch()"
      >
        <template v-slot:modalMessage>
          A previous search result is available
        </template>
      </ConfirmModal>
    </div>
    <!-- v-if="searchResults.length" -->
    <batch-actions
      v-if="searchResults.length && isBatchActionAccessible"
      :show-approver-form="showAddRemoveApprover && isSelectedSameClient"
      :search-table="selectedTable"
      :selected-refs="selectedSearchResults"
      :selected-clients="selectedClientList"
      @batch-action="doBatchAction($event)"
      @add-user="doBatchAction($event, 'ADD_USER')"
      @remove-user="doBatchAction($event, 'REMOVE_USER')"
      @replace-user="doBatchAction($event, 'REPLACE_USER')"
      @PDF="printBatchPDF($event)"
    />
    <ConfirmModal
      v-if="showModal"
      :is-info-modal="true"
      title="Notice"
      action="UPDATE_APPROVER"
      @okay-action="showModal = false"
    >
      <template v-slot:modalMessage>
        {{ $t('bulk.errors.sameClientError', { item: 'assignments' }) }}
      </template>
    </ConfirmModal>
    <update-modal v-if="isGeneratingPdf">
      <template v-slot:modalData>
        <vue-simple-spinner size="massive" />
      </template>
    </update-modal>
    <VueHtml2pdf
      ref="BatchDownloadComp"
      :show-layout="false"
      :paginate-elements-by-height="1400"
      pdf-format="a4"
      :manual-pagination="false"
      :enable-download="false"
      :preview-modal="true"
      :filename="`Timesheet-Batch`"
    >
      <section slot="pdf-content">
        <TimeSheetBatchPdf @readyToExport="exportAsPdf" />
      </section>
    </VueHtml2pdf>
    <VueHtml2pdf
      ref="ExpenseBatchDownloadComp"
      :show-layout="false"
      :paginate-elements-by-height="1400"
      pdf-format="a4"
      :manual-pagination="false"
      :enable-download="false"
      :preview-modal="true"
      :filename="`Expense-Batch`"
    >
      <section slot="pdf-content">
        <ExpensesBatchPDF @readyToExport="exportExpenseReportAsPdf" />
      </section>
    </VueHtml2pdf>
  </div>
</template>

<script>
import DataFilterForm from './forms/DataFilterForm';
import SearchExportActions from './actions/SearchExportActions';
import BatchActions from './actions/BatchActions.vue';
import TolTable from '../../components/TolTable';
import Checkbox from '@/app/components/Checkbox';
import Status from '@/app/components/Status';
import Pagination from '@/app/components/Pagination';
import ConfirmModal from '@/app/components/ConfirmModal';
import UpdateModal from '@/app/components/UpdateModal';
import { AppActions } from '@/app/app.keys';
import ThSortable from '@/app/components/ThSortable';
import DropdownSelect from '@/app/components/DropdownSelect';
import { timeSheetsListingService as timeSheetsService } from '@/app/features/time-sheets/features/time-sheets-listing/time-sheets-listing.service';
import { expensesListingService as expensesService } from '@/app/features/expenses/features/expenses-listing/expenses-listing.service';
import {
  AdvancedSearchGetters,
  AdvancedSearchActions
} from '@/app/features/advanced-search/advanced-search.keys';
import SearchResultFieldToggle from './forms/SearchResultFieldToggle.vue';
import TimeSheetBatchPdf from '../../features/time-sheets/features/time-sheet-details/components/TimeSheetBatchPdf';
import ExpensesBatchPDF from '../../features/expenses/features/expense-details/components/ExpensesBatchPDF';

export default {
  components: {
    DataFilterForm,
    TolTable,
    Status,
    SearchExportActions,
    Pagination,
    ThSortable,
    Checkbox,
    BatchActions,
    ConfirmModal,
    DropdownSelect,
    SearchResultFieldToggle,
    UpdateModal,
    TimeSheetBatchPdf,
    ExpensesBatchPDF
  },
  data() {
    return {
      searchClicked: false,
      changeParams: null,
      showAddRemoveApprover: false,
      showModal: false,
      defaults: null,
      menu: ['Assignments', 'Time Sheets', 'Expense Reports', 'Perm Placements']
    };
  },
  computed: {
    isLoading() {
      return this.$store.getters[AdvancedSearchGetters.SearchResultsIsLoading];
    },
    isGeneratingPdf() {
      return this.$store.getters[AdvancedSearchGetters.BatchPdfIsLoading];
    },
    sortableFields() {
      return this.$store.getters[AdvancedSearchGetters.SortableFields];
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    storeKey() {
      switch (this.selectedTable) {
        case 'Assignments':
          return 'AdvancedSearchGetters.AssignmentSearchFields';
        case 'Time Sheets':
          return 'AdvancedSearchGetters.TimeSheetSearchFields';
        case 'Expense Reports':
          return 'AdvancedSearchGetters.ExpenseSearchFields';
        case 'Perm Placements':
          return 'AdvancedSearchGetters.PermPlacementSearchFields';
        default:
          return '';
      }
    },
    currentSearchResultFields() {
      if (this.searchResults.length > 0)
        return this.$store.getters[this.storeKey].map(f => f.searchResultField).sort();
      return [];
    },
    selectedSearchResults() {
      return this.$store.getters[AdvancedSearchGetters.SelectedSearchResults];
    },
    selectedFields() {
      return this.$store.getters[AdvancedSearchGetters.AdvancedSearchParams].advancedSearchFields;
    },
    selectedTable() {
      return this.$store.getters[AdvancedSearchGetters.AdvancedSearchParams].advancedSearchTable;
    },
    selectedFilters() {
      return this.$store.getters[AdvancedSearchGetters.AdvancedSearchParams].advancedSearchFilters;
    },
    advancedSearchParams() {
      return this.$store.getters[AdvancedSearchGetters.AdvancedSearchParams];
    },
    searchResults() {
      return this.$store.getters[AdvancedSearchGetters.SearchResults];
    },
    viewFieldNames() {
      let names = this.$store.getters[AdvancedSearchGetters.AdvancedSearchParams]
        .advancedSearchFields;
      return names.map(n => this.underscorify(n));
    },
    searchResultsPerPage() {
      return this.$store.getters[AdvancedSearchGetters.SearchResultsPerPage];
    },
    currentPage() {
      return this.$store.getters[AdvancedSearchGetters.SearchResultsOffset];
    },
    searchResultsCount() {
      return this.$store.getters[AdvancedSearchGetters.SearchResultsRecordCount];
    },
    searchResultSortField() {
      return this.$store.getters[AdvancedSearchGetters.SearchResultsSortField];
    },
    searchResultSortDirection() {
      return this.$store.getters[AdvancedSearchGetters.SearchResultsSortDirection];
    },
    isSelectedSameClient() {
      const selectedClients = this.searchResults
        .filter(s => this.selectedSearchResults.includes(s.reference_number))
        .map(item => item.client_id);
      const hasSameClient = selectedClients.every(i => i === selectedClients[0]);
      return !!this.selectedSearchResults.length && hasSameClient;
    },
    selectedClientList() {
      return Array.from(
        new Set(
          this.searchResults
            .filter(s => this.selectedSearchResults.includes(s.reference_number))
            .map(item => item.client_id)
        )
      );
    },
    previousSearchResult() {
      return !this.searchClicked && this.searchResults.length > 0;
    },
    isBatchActionAccessible() {
      let selectedTable = this.$store.getters[AdvancedSearchGetters.AdvancedSearchParams]
        .advancedSearchTable;
      let permissionTableMap = this.$store.getters[AdvancedSearchGetters.PermissionsTableMap];

      return (
        this.currentUser &&
        this.currentUser.permissions &&
        this.currentUser.permissions[`ADVANCED_${permissionTableMap[selectedTable]}_SEARCH`] &&
        this.currentUser.permissions[`ADVANCED_${permissionTableMap[selectedTable]}_SEARCH`][
          'BATCH_ACTION'
        ]
      );
    }
  },
  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('advancedSearch.title'));
    this.$store.dispatch(AdvancedSearchActions.GetAdvancedSearchFields);
  },
  methods: {
    printBatchPDF() {
      let searchCategory = this.advancedSearchParams.advancedSearchTable;
      this.$store.dispatch(AdvancedSearchActions.SetBatchPdfLoading);
      switch (searchCategory) {
        case 'Expense Reports':
          expensesService.bulkUpdateExpenses({ action: 'PDF' }, this.selectedSearchResults);
          break;
        case 'Time Sheets':
          timeSheetsService.bulkUpdateTimeSheets({ action: 'PDF' }, this.selectedSearchResults);
          break;
      }
    },
    underscorify(str) {
      let tokens = str.split(' ');
      tokens = tokens.map(t => t.toLowerCase());
      return tokens.join('_');
    },
    doAdvancedSearch() {
      if (!this.selectedTable) return;

      this.searchClicked = true;

      this.$store.dispatch(AdvancedSearchActions.DoAdvancedSearch);
    },
    showDefaultUIForSelected(evt) {
      this.setSearchTable(evt);
      let defaultFields = [];

      if (this.currentUser) {
        const userRoles = this.currentUser.roles.map(r => r.role_name);
        if (userRoles.includes('System Admin')) {
          defaultFields = this.$store.getters[AdvancedSearchGetters.DefaultUIFields][
            'System Admin'
          ][this.selectedTable];
        } else if (userRoles.includes('Branch Admin')) {
          defaultFields = this.$store.getters[AdvancedSearchGetters.DefaultUIFields][
            'Branch Admin'
          ][this.selectedTable];
        } else if (userRoles.includes('Payroll')) {
          defaultFields = this.$store.getters[AdvancedSearchGetters.DefaultUIFields]['Payroll'][
            this.selectedTable
          ];
        } else if (userRoles.includes('Recruiter') || userRoles.includes('Account Manager')) {
          defaultFields = this.$store.getters[AdvancedSearchGetters.DefaultUIFields]['Recruiter'][
            this.selectedTable
          ];
        } else {
          defaultFields = this.$store.getters[AdvancedSearchGetters.DefaultUIFields]['default'][
            this.selectedTable
          ];
        }

        const allFilters = this.$store.getters[AdvancedSearchGetters.FilterFields];
        this.defaults = allFilters.filter(f => defaultFields.includes(f.label));
      }
    },
    clearDefaultUIForSelected() {
      this.$store.dispatch(AdvancedSearchActions.ClearSearchTableOrField, {
        key: 'searchTable',
        value: ''
      });
    },

    setSearchTable(evt) {
      if (evt !== this.selectedTable) {
        this.changeParams = {
          clearAll: true,
          removeOne: null
        };

        this.$store.dispatch(AdvancedSearchActions.SetSearchTableOrField, {
          key: 'searchTable',
          value: evt
        });
        this.$store.dispatch(AdvancedSearchActions.ClearSearchTableOrField, {
          key: 'searchTable',
          value: evt
        });
      }
    },
    setSearchField(evt) {
      this.$store.dispatch(AdvancedSearchActions.SetSearchTableOrField, {
        key: 'searchField',
        value: evt
      });
    },
    removeSearchField(evt) {
      this.changeParams = {
        clearAll: false,
        removeOne: evt
      };

      this.$store.dispatch(AdvancedSearchActions.ClearSearchTableOrField, {
        key: 'searchField',
        value: evt
      });
    },
    handleSearchRowClicked(evt) {
      this.$store.dispatch(AdvancedSearchActions.ShowResultDetails, evt);
    },
    onChangePaginationParams(event) {
      this.$store.dispatch(AdvancedSearchActions.SetSearchPaginationParameters, event);
    },
    onSortOrderChange(sortOrder) {
      this.$store.dispatch(AdvancedSearchActions.SetAdvancedSearchSortOrder, sortOrder);
    },
    onToggleSelectSearchResult(referenceNumber) {
      this.$store.dispatch(AdvancedSearchActions.ToggleSelectSearchResult, referenceNumber);
    },
    doBatchAction(evt, approverAction = null) {
      if (this.selectedSearchResults.length > 0 && evt.action === 'UPDATE_APPROVER') {
        this.showAddRemoveApprover = !this.showAddRemoveApprover;
        this.showModal = !this.isSelectedSameClient;
      } else {
        if (!approverAction) {
          this.$store.dispatch(AdvancedSearchActions.DoBatchAction, {
            action: evt,
            table: this.selectedTable
          });
        } else {
          let action = {
            action: approverAction,
            comment: evt.comment
          };
          this.$store.dispatch(AdvancedSearchActions.DoBatchAction, {
            action,
            table: this.selectedTable,
            clientContact: evt.user
          });
        }
      }
    },
    cancelPreviousSearch() {
      this.searchClicked = false;
      this.$store.dispatch(AdvancedSearchActions.ClearSearchTableOrField, {
        key: 'searchTable',
        value: ''
      });
    },
    exportAsPdf() {
      this.$refs.BatchDownloadComp.generatePdf();
    },
    exportExpenseReportAsPdf() {
      this.$refs.ExpenseBatchDownloadComp.generatePdf();
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors';
@import '@/app/styles/variables';
@import '@/app/styles/action-buttons';

.search-header,
.report-builder {
  display: flex;
  padding: 60px;
  background-color: $white;
  .search-container {
    flex: 1;
  }
}
.report-builder {
  flex-direction: column;
  .rb-msg {
    font-size: 3rem;
    color: #ccc;
    margin-bottom: 60px;
  }

  .bl {
    display: flex;
    align-items: center;
    //flex-direction: column;
    margin-bottom: 15px;
    span {
      display: inline-flex;
      width: 120px;
    }
    .rb-input {
      flex-basis: 600px;
      &.ext {
        flex-basis: 720px;
      }
    }
    &.right {
      justify-content: flex-end;
    }

    .btn {
      width: 250px;
      height: 60px;
    }

    &.main {
      border: 1px solid $row-border;
      padding: 12px;
    }
  }
}
.form-container {
  display: block;
  width: 50%;
  margin: auto;
}

.row-select {
  &:hover {
    .checkbox.regular {
      border: 1px solid $blue;
    }
  }
}

.search {
  width: 250px;
  height: 60px;
  font-size: 1.2em;
  color: $white;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $secondary-green;
  font-weight: bold;
  cursor: pointer;
  &:hover {
    background-color: $green;
  }
  &.disabled {
    background-color: $light-grey-2;
    color: $light-grey-1;
    &:hover {
      background-color: $light-grey-2;
      color: $light-grey-1;
    }
  }
}
</style>
